var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('list-search', _vm._b({
    attrs: {
      "hide-actions": ""
    }
  }, 'list-search', {
    showsSearch: _vm.showsSearch,
    loading: _vm.loading
  }, false), [_c('v-row', {
    staticClass: "ma-n1"
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('search-duration', {
    on: {
      "input": _vm.push
    },
    model: {
      value: _vm.query['searchDateValue'],
      callback: function callback($$v) {
        _vm.$set(_vm.query, 'searchDateValue', $$v);
      },
      expression: "query['searchDateValue']"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }